import React from "react"
import GImage from "gatsby-image"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import SocialLinks from "../constants/socialLinks"
//import links from "../constants/links"
import PortfolioParticles from "./PortfolioParticles"

// ...GatsbyImageSharpFluid

const query = graphql`
  {
    file(relativePath: { eq: "german-portrait-border.png" }) {
      childImageSharp {
        fixed {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
const Hero = () => {
  const data = useStaticQuery(query)

  const {
    file: {
      childImageSharp: { fixed },
    },
  } = data

  return (
    <div className="info-wrapper">
      <PortfolioParticles particleColor="#FFFFFF" linkColor="#FFFFFF" />
      <header className="hero">
        <div className="section-center hero-center">
          <article className="hero-info">
            <div>
              <h1>Germán Reyes</h1>
              <h4>
                I'm a CompSci and Technology student who loves Web Development{" "}
                {/*Laptop and Heart emojis*/}
                &#128187;&#129505;
              </h4>
              <Link to="/contact" className="btn">
                Contact me
              </Link>
              <SocialLinks />
            </div>
          </article>
          <GImage
            fixed={fixed}
            className="hero-img"
            style={{ display: "inherit" }}
          />
        </div>
      </header>
    </div>
  )
}

export default Hero
